import React, { ReactNode } from "react";
import { useFormContext } from "react-hook-form";
import { type AutocompleteRenderOptionState, Form } from "@sscs/ui";
import { getClassName } from "@sscs/utils";
import { ORG_ROLE_DETAILS } from "Constants";
import { OrgRole } from "Types";
import styles from "./organizationalRoleAutocomplete.module.scss";

const renderOption = (
  props: React.HTMLAttributes<HTMLLIElement>,
  option: OrgRole,
  { selected }: AutocompleteRenderOptionState,
): ReactNode => {
  const findOption = ORG_ROLE_DETAILS[option];
  const cls = getClassName(styles["select-role"], {
    [styles["select-role-selected"]]: selected,
  });

  return (
    <li {...props} className={cls}>
      <div>
        {findOption?.label}
        <br />
        <Form.HelperText>{findOption?.helperText}</Form.HelperText>
      </div>
    </li>
  );
};

const OrganizationRoleAutocomplete = (props: {
  id?: string;
}): React.JSX.Element | null => {
  const {
    formState: { errors },
  } = useFormContext<{ orgRole: string }>();

  return (
    <Form.Autocomplete
      {...props}
      name="orgRole"
      label="Organization role"
      errors={errors}
      multiSelect={false}
      isRequired
      isClearable={false}
      options={Object.keys(ORG_ROLE_DETAILS) as OrgRole[]}
      renderOption={renderOption}
      getOptionLabel={(option) =>
        ORG_ROLE_DETAILS[option as OrgRole]?.label ?? ""
      }
    />
  );
};

export default OrganizationRoleAutocomplete;
